import React from 'react'
import { SnopMarkingPage } from '@auteco/pages'

const SnopMarkingContainer = () => {
    const info = []
    return (
        <SnopMarkingPage />
    )
}

export { SnopMarkingContainer }